// export const API_BASE_URL =
//   "https://sz9kisfls6.execute-api.eu-west-1.amazonaws.com/api/v2/";
export const API_BASE_URL = "https://sz9kisfls6.execute-api.eu-west-1.amazonaws.com/api/v2/";
